import { render, staticRenderFns } from "./UploadFileEditor.vue?vue&type=template&id=65e5c092"
import script from "./UploadFileEditor.vue?vue&type=script&lang=js"
export * from "./UploadFileEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports